import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchExaminations } from '../../../../store/actions/examinationsActions'
import { PlusIcon } from '@heroicons/react/solid'
import Loader from '../../../../components/elements/Loader'
import Pagination from '../../../../components/elements/Pagination'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import ExaminationCard from '../../../../components/partials/examinations/ExaminationCard'
import EditExamination from '../../../../components/partials/examinations/EditExamination'
import { fetchFees } from '../../../../store/actions/feesActions'
import NewExamination from '../../../../components/partials/examinations/NewExamination'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import ChevronIcon from '../../../../components/elements/icons/ChevronIcon'
import ExaminationCenters from '../../../../components/partials/examinations/centers/ExaminationCenters'
import NewExaminationCenter from '../../../../components/partials/examinations/centers/NewExaminationCenter'
import { clearCreatedExaminationCenter } from '../../../../store/actions/examinationCentersActions'
import { SET_SUCCESS } from '../../../../store/types'

const Examinations = () => {
  const dispatch = useDispatch()
  const examsSelector = useSelector(state => state.examinations)
  const examinationCentersSelector = useSelector(state => state.examinationCenters)
  const [reload, setReload] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(30);

  useEffect(() => {
    dispatch(fetchFees())
    dispatch(fetchExaminations('', page, perPage))

    if(examinationCentersSelector.createdExaminationCenter !== null){
      setCreatingExaminationCenter(false)
      dispatch(clearCreatedExaminationCenter())
      dispatch({
        type: SET_SUCCESS,
        payload: 'new examination center created successfully!'
      })
    }
    return () => {
      
    };
  }, [page, perPage, dispatch, reload, examinationCentersSelector.createdExaminationCenter]);

  const [creatingExamination, setCreatingExamination] = useState(false);
  const [editingExamination, setEditingExamination] = useState(false);
  const [activeExamination, setActiveExamination] = useState(null);

  const openExamination = (fee) => {
    setActiveExamination(fee)
    setTimeout(() => {
      setEditingExamination(true)
    }, 50);
  }

  const closeExamination = () => {
    setEditingExamination(false)
    setTimeout(() => {
      setActiveExamination(null)
    }, 50);
  }

  const [centersSectionOpen, setCentersSectionOpen] = useState(false);
  const [creatingExaminationCenter, setCreatingExaminationCenter] = useState(false);

  return (
    <>
      <AdministrationLayout pageTitle="Examinations">
        <div className='w-full'>
          <div className='w-full flex justify-between'>
            <div className='w-9/12'>
              <h3 className='text-lg font-medium'>Vaatia college Examinations </h3>
              <p className='text-sm'>All examinations scheduled in vaatia college Makurdi. These examinations can be tied to any students, classes or admissions and you can create new examinations anytime by clicking on the "Create Examination" button</p>
            </div>
            <div>
              <button onClick={()=>{setCreatingExamination(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                <PlusIcon className='w-5 h-5' /> Create examination
              </button>
            </div>
          </div>

          {/* Examination Centers */}

          <div className={`w-full bg-gray-100 p-4 rounded-t-[8px] border mt-6 ${centersSectionOpen ? 'rounded-b-0' : 'rounded-b-[8px]'}`}>
            <div className='cursor-pointer w-full flex items-center justify-between'>
              <div>
                <div className='flex items-center gap-x-3'>
                  <h3 className='font-[500]'>Examination Centers</h3>
                  <button onClick={()=>{setCreatingExaminationCenter(true)}} className='text-vcm-purple bg-vcm-light-purple bg-opacity-20 p-2 transition text-xs duration-200 hover:text-violet-600 font-medium underline'>Create new examination center</button>
                </div>
                <p onClick={()=>{setCentersSectionOpen(!centersSectionOpen)}} className='text-sm text-gray-500'>Click here to see a list of Examinations centers created. You can also create new sections in this section.</p>
              </div>
              <div className='w-[50px] flex items-center justify-center'>
                <button onClick={()=>{setCentersSectionOpen(!centersSectionOpen)}}>
                  <ChevronIcon className={`w-5 h-5 text-gray-500  transition duration-200 ${centersSectionOpen ? 'rotate-[270deg]' : 'rotate-180'}`} />
                </button>
              </div>
            </div>
          </div>
          {centersSectionOpen && <div className='bg-gray-50 w-full rounded-b-[8px] border-l border-r border-b border-gray-300 p-8'>
            <ExaminationCenters />
          </div>}

          {examsSelector.loadingExaminations
          ? 
          <Loader /> 
          :
          <>
            {examsSelector?.examinations?.examinations && examsSelector?.examinations?.examinations?.length > 0 
              ? 
                <>
                  <div className='mt-8 mb-5 grid grid-cols-3 gap-8'>
                    {examsSelector?.examinations?.examinations?.map((exam, examIndex) => (
                      <div key={examIndex}>
                        <ExaminationCard examination={exam} openExamination={()=>{openExamination(exam)}} />
                      </div>
                    ))}
                  </div> 
                  <Pagination 
                    pagination={{
                      perPage, 
                      page,
                      totalItems: examsSelector.examinations.total,
                    }} 
                    changePage={setPage} 
                    updatePerPage={setPerPage}
                  />
              </>
              : 
              <div className='h-[300px] w-full flex items-center justify-center'>
                <EmptyState emptyStateText='No examination have been created yet. Click on create examination above to create a new one'></EmptyState>
              </div>
            }
          </>}

        </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingExamination} 
        closeFunction={()=>{setCreatingExamination(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Examination`}
        dialogTitle='Create a new Examination'
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <NewExamination 
          description={`Create a new examination`} 
          reload={()=>setReload(reload+1)}
          closeFunction={()=>{setCreatingExamination(false)}} 
        />
      </ModalDialog>

      {activeExamination && <ModalDialog
        shown={editingExamination} 
        closeFunction={()=>{closeExamination()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Update Examination`}
        dialogTitle='Update examination'
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <EditExamination 
          description={`Change the required details and save to update the fee`} 
          reload={()=>setReload(reload+1)}
          examination={activeExamination}
          closeFunction={()=>{closeExamination()}} 
        />
      </ModalDialog>}

      <ModalDialog
        shown={creatingExaminationCenter} 
        closeFunction={()=>{setCreatingExaminationCenter(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Examination Center`}
        dialogTitle='Create a new Examination Center'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <NewExaminationCenter 
          description={`Create a new examination center`} 
          reload={()=>setReload(reload+1)}
          closeFunction={()=>{setCreatingExaminationCenter(false)}} 
        />
      </ModalDialog>
    </>
  )
}

export default Examinations